import { render, staticRenderFns } from "./CompletedPlug.vue?vue&type=template&id=260b87ae"
import script from "./CompletedPlug.vue?vue&type=script&lang=js"
export * from "./CompletedPlug.vue?vue&type=script&lang=js"
import style0 from "./CompletedPlug.vue?vue&type=style&index=0&id=260b87ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports